import { useTheme } from "@mui/material/styles";

const LocationIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.03328 8.03353C7.13785 8.03353 8.03328 7.1381 8.03328 6.03353C8.03328 4.92896 7.13785 4.03353 6.03328 4.03353C4.92871 4.03353 4.03328 4.92896 4.03328 6.03353C4.03328 7.1381 4.92871 8.03353 6.03328 8.03353Z"
        stroke={theme.palette.otherTextTertiary.main}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.03328 14.0335C8.69995 11.3669 11.3666 8.97905 11.3666 6.03353C11.3666 3.08801 8.9788 0.700195 6.03328 0.700195C3.08777 0.700195 0.699951 3.08801 0.699951 6.03353C0.699951 8.97905 3.36662 11.3669 6.03328 14.0335Z"
        stroke={theme.palette.otherTextTertiary.main}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LocationIcon;
